import { bufferToggle, concatAll } from "rxjs/operators";
export function holdToggle(captures, releaseSelector) {
    return (source) => source.pipe(bufferToggle(captures, releaseSelector), concatAll());
}
//# sourceMappingURL=holdToggle.js.map